import { FC, ReactNode } from 'react';
import { TrackingRegion } from '../../../AnalyticsContext/TrackingData';
import { renderRegionTracking } from '../../../AnalyticsContext/renderRegionTracking';
import { useHomepageTiles } from '../../../Experiments/HomepageTilesExperiment';
import {
  PageSectionContainer,
  PageSectionContainerExperiment,
  PageSectionWrapper,
} from './PageSection.styles';

interface PageSectionProps {
  backgroundElement?: ReactNode;
  className?: string;
  trackingRegionId?: TrackingRegion;
  topNavExperiment?: boolean;
}

export const PageSection: FC<PageSectionProps> = ({
  children,
  className,
  backgroundElement,
  trackingRegionId,
  topNavExperiment,
}) => {
  const homepageTilesExperiment = useHomepageTiles();

  return (
    <PageSectionWrapper className={className} {...renderRegionTracking(trackingRegionId)}>
      {backgroundElement}
      {homepageTilesExperiment ? (
        <PageSectionContainerExperiment>{children}</PageSectionContainerExperiment>
      ) : (
        <PageSectionContainer topNavExperiment={topNavExperiment}>{children}</PageSectionContainer>
      )}
    </PageSectionWrapper>
  );
};
